export const defaultLinks = [
  {
    title: 'Home',
    to: '/',
  },
];

export const guestLinks = [
  {
    title: 'Sign in',
    to: '/login',
  },
  {
    title: 'Sign up',
    to: '/register',
  },
];

export const userLinks = [
  {
    title: 'New Post',
    to: '/article/new',
  },
  {
    title: 'Settings',
    to: '/settings',
  },
];
